import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#008080', // Teal
      light: '#33a1a1',
      dark: '#005353',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#FF8749', // Coral
      light: '#FF9673',
      dark: '#A94000',
      contrastText: '#000000'
    },
    background: {
      default: '#f4f4f9', // Light grey for background
      paper: '#ffffff' // White for paper elements
    },
    text: {
      primary: '#333333', // Dark grey for primary text
      secondary: '#666666', // Medium grey for secondary text
      disabled: '#999999' // Light grey for disabled text
    },
    error: {
      main: '#dc2626', // Red for error/destructive states
      light: '#ef4444',
      dark: '#b91c1c',
      contrastText: '#ffffff'
    },
    warning: {
      main: '#ffa000' // Amber for warnings
    },
    info: {
      main: '#0288d1' // Light blue for info
    },
    success: {
      main: '#388e3c' // Green for success
    },
    divider: '#e0e0e0' // Light grey for dividers
  },
  typography: {
    fontFamily: 'Tahoma',
    h1: {
      fontSize: 24,
      fontWeight: 'bold'
    },
    h2: {
      fontSize: 20,
      fontWeight: 'bold'
    },
    h3: {
      fontSize: 18,
      fontWeight: 'bold'
    }
  },
  components: {
    MuiTextField: {
      defaultProps: {
        size: 'small',
        fullWidth: true
      }
    },
    // Client review 2026-11-01: a screen's main action is the one filled button, others are
    // outlined (or text, for Retry/Back), in normal letters rather than capitals, without a shadow.
    MuiButton: {
      defaultProps: {
        variant: 'contained',
        disableElevation: true
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 4
        }
      }
    }
  }
});

export default theme;
